import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const PDIEmirGiris = () => {
    return (
        <>
            <ExcelUpload
                role_name={"pdi_emri_write"}
                requiredColumnsSase={["sase", "PLANLAMA TARIHI", "YENİ/IPTAL"]}
                process_type="PDI"
                ExcelName={"PDI Emri Hatalı Şaseler"}
                Title={"PDI Emri Yükle"}
                exampleData={[
                    {
                        sase: "VF3YEF6F0RMA03711",
                        "PLANLAMA TARIHI": "01.01.2025",
                        "YENİ/IPTAL": "YENİ"
                    },
                    {
                        sase: "VF3YEF6F0RMA03711",
                        "PLANLAMA TARIHI": "01.01.2025",
                        "YENİ/IPTAL": "IPTAL"
                    }
                ]}
            />
        </>
    )
}

export default PDIEmirGiris